import React from "react";
import classNames from "classnames";
import HeartFillSvgIcon from "jsx:../../../assets/svgs/filled-heart.svg";
import HeartEmptySvgIcon from "jsx:../../../assets/svgs/empty-heart.svg";

const ItemImage = ({
  isItemOpen,
  isFavourite,
  showFavourite = false,
  toggleFavourite,
  position,
  logoSmallUrl,
  product_image,
  itemImageAlignSelf,
}) => {
  function handleImageError(event) {
    event.target.classList.add("error-img");
  }

  return (
    <div
      className={classNames(
        `${position}-item__image`,
        {
          [`${position}-item__image-small`]: !isItemOpen,
        },
        itemImageAlignSelf && itemImageAlignSelf,
      )}
    >
      <div className={`${position}-item__sml-img`}>
        <img
          className={`${position}-item__sml-${
            product_image ? "" : "default-"
          }image`}
          src={product_image || logoSmallUrl}
          alt="img"
          onError={handleImageError}
        />
        {showFavourite && (
          <>
            {isFavourite ? (
              <HeartFillSvgIcon
                onClick={toggleFavourite}
                className={classNames("heart-icon heart-icon__small", "heart-icon__filled")}
              />
            ) : (
              <HeartEmptySvgIcon
                onClick={toggleFavourite}
                className={classNames(
                  "heart-icon heart-icon__small",
                  "heart-icon__empty",
                )}
              />
            )}
          </>
        )}
      </div>
    </div>
  );
};
export default ItemImage;
